(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxSelectGoProfile(
    $http, $timeout, GoProfilePaging, GoProfileService, toastr, $filter
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        printer: '=printer',
        tenant: '=resource',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/printerProperties/printerGoProfile/selectGoProfile/selectGoProfile.template.html',
      link: function(scope) {

        scope.paginationObject = new GoProfilePaging();
        var scrollEnd = null;
        var containerHeight = null;
        scope.searchString = '';
        scope.selectedGoProfile = null;

        (function() {
          getFirstPage();
        })();

        ////////////////////////////////////
        ////////////////////////////////////
        //////  Pagination stuff
        ////////////////////////////////////
        function getFirstPage () {
          scope.paginationObject.pagingCriteria.pageSize = 10;
          scope.list = [];
          scope.loadingPage = true;
          GoProfileService.getGoProfilePaged(scope.paginationObject).then(function(printerSignInProfiles) {
            window.scrollTo(0,0);
            scope.loadingPage = false;
            scope.totalPages = printerSignInProfiles.page.totalPages;
            if (printerSignInProfiles.list) {
              scope.list = printerSignInProfiles.list;
            }
          }).catch(function(error) {});
        }

        scope.textSearch = function () {
          scope.paginationObject.pagingCriteria.match = scope.searchString;
          scope.list = [];
          $timeout(function () {
            getFirstPage();
          }, 500)
        }

        function getNextPage () {
          if (!scope.loadingPage && scope.totalPages > scope.paginationObject.pagingCriteria.page + 1) {
            scope.loadingPage = true;
            scope.paginationObject.pagingCriteria.page += 1;
            GoProfileService.getGoProfilePaged(scope.paginationObject).then(function(printerSignInProfiles){
              if (printerSignInProfiles.list) {
                scope.list = scope.list.concat(printerSignInProfiles.list);
              }
              scope.loadingPage = false;
            }).catch(function(error) {});
          }
        }

        angular.element('.item-list-nested').on('scroll', function (event) {
          scrollEnd = event.currentTarget.clientHeight + event.currentTarget.scrollTop + 1;
          containerHeight = event.currentTarget.scrollHeight;
          if (!scope.loadingPage && scope.totalPages > scope.paginationObject.pagingCriteria.page + 1) {
            if (scrollEnd > containerHeight) {
              $timeout(function() {
                getNextPage();
              }, 300)
            }
          }
        });

        scope.$on('$destroy', function() {
          angular.element('.item-list-nested').off('scroll');
        });


        ////////////////////////////////////
        ////////////////////////////////////
        //////  Select & Save on printer
        ////////////////////////////////////
        scope.selectSignInProfile = function (signInProfilePreset) {
          scope.selectedGoProfile = signInProfilePreset;
        }

        scope.signInOnPrinter = function () {
          var url = scope.printer.info._links['px:printerCredential'].href;
          $http.post(url, scope.selectedGoProfile.info._links.self.href).then(function(response) {
            toastr.success($filter('translate')('ChangesSaved'));
          }).catch(function(error) {
            toastr.error($filter('translate')('ERROR'));
          });
          scope.callback();
        }

      }
    };
  }

  pxSelectGoProfile.$inject = [
    '$http', '$timeout', 'GoProfilePaging', 'GoProfileService', 'toastr', '$filter'
  ];

  angular
    .module('printix-admin')
    .directive('pxSelectGoProfile', pxSelectGoProfile);

})();
